import { render, staticRenderFns } from "./yichaos.vue?vue&type=template&id=495930b0&scoped=true&"
import script from "./yichaos.vue?vue&type=script&lang=js&"
export * from "./yichaos.vue?vue&type=script&lang=js&"
import style0 from "./yichaos.vue?vue&type=style&index=0&id=495930b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495930b0",
  null
  
)

export default component.exports